import { sizes } from '../../../../assets/code-snippets/column/snip'
import Snippet from '../../../../components/Snippet/Snippet'

const Sizes = () => {
    return <div className="container fluid" id="sizes-basics">

        <div className="container fluid">
            <p className="text xl"><a href="#sizes-basics" className="link">&#128279;</a> Column Sizes </p>
            <p className="text lg">You can define each column width in your web layout.</p>
        </div>

        <div className="container sm py-2">
            <Snippet code={sizes} language='html' />
        </div>

        <div className="container fluid py-3 px-1">
            <p className="text md">Columns having a defined width are able to split a layout in 6 parts
            maximum, each <code>.col</code> needs to have another class defined which will define the
            maximum width of that <code>div</code>, these sized
            are identified by roman letters which means their unit size in latin numeral, such as:
        </p>
            <ol>
                <li>
                    <p className="text"><code className="bold">I</code> - means 1 unit</p>
                </li>
                <li>
                    <p className="text"><code className="bold">II</code> - means 2 units</p>
                </li>
                <li>
                    <p className="text"><code className="bold">III</code> - means 3 units</p>
                </li>
                <li>
                    <p className="text"><code className="bold">IV</code> - means 4 units</p>
                </li>
                <li>
                    <p className="text"><code className="bold">V</code> - means 5 units</p>
                </li>
                <li>
                    <p className="text"><code className="bold">VI</code> - means 6 units - <span className="info">will
                        cover the entire width of its parent</span>
                    </p>
                </li>
            </ol>
            <div className="column gap-10 primary">
                <div className="col I text-center p-2">1 unit</div>
                <div className="col II text-center p-2">2 unit</div>
                <div className="col III text-center p-2">3 unit</div>
                <div className="col IV text-center p-2">4 unit</div>
                <div className="col V text-center p-2">5 unit</div>
                <div className="col VI text-center p-2">6 unit</div>
            </div>
        </div>

    </div>
}
export default Sizes